import { Send } from "lucide-react";
import { Button } from "@/components/ui/button";

interface TelegramChatButtonProps {
  username: string;
  recipientName: string;
  size?: "default" | "sm" | "lg" | "icon";
  variant?: "default" | "outline" | "ghost";
}

export const TelegramChatButton = ({
  username,
  recipientName,
  size = "default",
  variant = "default",
}: TelegramChatButtonProps) => {
  const handleClick = () => {
    // Supprimer le @ si présent
    const cleanUsername = username.startsWith("@") ? username.slice(1) : username;
    const telegramUrl = `https://t.me/${cleanUsername}`;
    window.open(telegramUrl, "_blank");
  };

  return (
    <Button
      onClick={handleClick}
      size={size}
      variant={variant}
      className="bg-[#0088cc] hover:bg-[#0077b5] text-white"
    >
      <Send className="h-4 w-4 mr-2" />
      Telegram
    </Button>
  );
};
